document.addEventListener("DOMContentLoaded", () => {
  const cartItems = document.querySelectorAll(".cart-item");

  cartItems.forEach((item) => {
    const linkId = item.dataset.linkId;
    const itemKey = item.dataset.key;
    const quantityInput = item.querySelector(".quantity__input");
    const removeButton = item.querySelector("[data-remove-button]");

    if (!itemKey || !quantityInput) return;

    quantityInput.addEventListener("change", (e) => {
      const newQty = parseInt(e.target.value, 10);
      syncLinkedItems(linkId, newQty);
    });

    if (removeButton) {
      removeButton.addEventListener("click", (e) => {
        e.preventDefault();
        syncLinkedItems(linkId, 0);
      });
    }
  });

  function syncLinkedItems(linkId, newQty) {
    const linkedItems = document.querySelectorAll(
      `.cart-item[data-link-id="${linkId}"]`
    );

    const updates = {};
    linkedItems.forEach((el) => {
      const key = el.dataset.key;
      if (key) {
        updates[key] = newQty;
      }
    });

    if (Object.keys(updates).length > 0) {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      })
        .then((res) => res.json())
        .then((cart) => {
          location.reload();
        })
        .catch((err) => console.error("Cart update error", err));
    }
  }
});
